import * as React from "react";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
	closeButton: {
		position: 'absolute',
		right: '7px',
		top: '7px',
		color: '#888',
	},
	title: {
		marginRight: '30px',
		textTransform: 'none',
	}
}));

export interface IDialogTitleProps {
	children: React.ReactNode;
	onClose: () => void;
}

const DialogTitleWithClose = (props: IDialogTitleProps) => {
	const classes = useStyles();
	const { children, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography  {...other}>
			<Typography variant="h6" className={classes.title} >{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
}

export default DialogTitleWithClose;